var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPinOrange = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "128px",
    height: "128px",
    viewBox: "0 0 128 128",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Lunacy")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0.78981483,
    y1: 0.07742256,
    x2: 0.49586272,
    y2: 0.41933155,
    id: "gradient_1"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#F2D297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4B134"
  })), /*#__PURE__*/React.createElement("rect", {
    width: 128,
    height: 128,
    id: "artboard_1"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip_1"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#artboard_1",
    clipRule: "evenodd"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "128-x-128",
    clipPath: "url(#clip_1)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#artboard_1",
    stroke: "none",
    fill: "#FFFFFF",
    fillOpacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "pin",
    transform: "translate(17 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.6116 0.00835087C70.086 -0.405298 93.8976 14.5413 93.8976 46.3838C93.8976 78.2262 46.6116 127.378 46.6116 127.378C46.6116 127.378 0 79.8808 0 48.0384C0 16.1959 23.1371 0.422 46.6116 0.00835087Z",
    id: "pin",
    fill: "url(#gradient_1)",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 14C0 6.26801 6.26801 0 14 0C21.732 0 28 6.26801 28 14C28 21.732 21.732 28 14 28C6.26801 28 0 21.732 0 14Z",
    transform: "translate(32.927635 25.00001)",
    id: "pin-center",
    fill: "#FFFFFF",
    stroke: "none"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPinOrange);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/pinOrange.cae9319aa2c79a69e4b28fe852f76384.svg";